var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['v-slider']},[_c('transition',{class:_vm.$style['content'],attrs:{"name":"slide","tag":"div","css":false},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"leave":_vm.leave}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }